export default __webpack_public_path__ + "static/fire-19bab35bddb648ef719e675f5325d96b.png";